import { sha256 as sha256Hasher } from "@noble/hashes/sha2.js";

const FILE_READ_CHUNK_BYTES = 4 * 1024 * 1024;

export async function portableBlobSha256(file: Blob, signal?: AbortSignal): Promise<string> {
  const hasher = sha256Hasher.create();
  for (let offset = 0; offset < file.size; offset += FILE_READ_CHUNK_BYTES) {
    if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
    hasher.update(
      new Uint8Array(
        await file.slice(offset, offset + FILE_READ_CHUNK_BYTES).arrayBuffer(),
      ),
    );
  }
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  const digest = hasher.digest();
  return `sha256:${Array.from(digest, (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("")}`;
}

